import { get } from 'api/helpers';
import env from 'utilities/env';

export const getMagicAlgorithmResults = () => {
  const magicUrl = env('MAGIC_ALGORITHM_AWS_BUCKET');

  return get(magicUrl);
};


export default getMagicAlgorithmResults;
